import { styled } from "../../../styled-components";
import { mobileSystemFontFamily } from "../../../lib/theme/theme";
import Img from "../../smart/img/img";

export const UserImageWrapper = styled(Img)<{ size: number }>`
    overflow: hidden;
    border-radius: 1000px;

    height: ${p => p.size}px;
    width: ${p => p.size}px;

    flex-shrink: 0;

    position: relative;
    object-fit: cover;
`;

export const FallbackWrapper = styled.div<{ fontSize: number; background: string }>`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;

    background-color: ${p => (p.background === "accent" ? p.theme.primaryAccentColor : p.background)};
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    font-size: ${p => p.fontSize}px;
    font-weight: 500;
    font-family: ${mobileSystemFontFamily};

    color: ${p => (p.background === "accent" ? p.theme.accentForegroundColor : "white")};
`;
